import { Link } from 'react-router-dom';

const FEATURES = [
  {
    icon: 'ri-quill-pen-line',
    title: 'AI-Generated Ad Copy',
    body: 'AdForge writes your hooks, headlines, body copy, and CTAs automatically. Just tell it your trade, your goal, and your offer — it handles the words.',
    tag: 'No writing skills needed',
  },
  {
    icon: 'ri-image-edit-line',
    title: 'AI-Generated Visuals',
    body: 'Get up to 6 professional ad images per run — created by AI, sized for each platform. No designer, no stock photo subscription, no Canva.',
    tag: 'Up to 6 images per ad',
  },
  {
    icon: 'ri-global-line',
    title: 'Built for Facebook, Instagram & Google',
    body: 'Every ad is formatted and optimized for the platform you choose. Facebook ads for contractors, Google search ads, Instagram stories — all covered.',
    tag: 'Multi-platform ready',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Fast & Dead Simple',
    body: 'Fill out a short form, hit generate, and your full ad package is ready in under 3 minutes. No learning curve. No tech skills required.',
    tag: 'Ready in &lt; 3 minutes',
  },
];

export default function ContractorHowHelps() {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-500 uppercase tracking-widest mb-3">
            How AdForge Helps
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-stone-900 mb-4 leading-tight">
            Everything You Need for Contractor Advertising — Done by AI
          </h2>
          <p className="text-base text-stone-500 max-w-xl mx-auto">
            AdForge is the only <strong>AI ads for contractors</strong> tool that handles copy,
            visuals, and platform formatting all in one place.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              className="flex gap-5 p-6 rounded-2xl bg-stone-50 border border-stone-100 hover:border-orange-200 transition-colors duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-100 text-orange-500 flex-shrink-0">
                <i className={`${f.icon} text-2xl`} />
              </div>
              <div className="flex flex-col gap-2">
                <h3 className="text-base font-bold text-stone-900">{f.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed">{f.body}</p>
                <span
                  className="inline-block text-xs font-semibold text-orange-600 bg-orange-50 border border-orange-100 rounded-full px-3 py-1 w-fit"
                  dangerouslySetInnerHTML={{ __html: f.tag }}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center">
          <Link
            to="/signup"
            className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Try It Free — No Credit Card Needed
          </Link>
        </div>
      </div>
    </section>
  );
}
